import BenchlingConfig from 'BenchlingConfig';
import {SampleControlsFeatureLevel} from 'inventory/sample-status/SampleControlsFeatureLevel';

// Exported for testing only
// Keep in sync with benchling/inventory/sample_roles/sample_controls_feature_level_util.py
export function _isSCRFeatureLevelSupported(
  currentLevel: SampleControlsFeatureLevel,
  minimumLevel: SampleControlsFeatureLevel
): boolean {
  switch (minimumLevel) {
    case SampleControlsFeatureLevel.OFF:
      return true;
    case SampleControlsFeatureLevel.V1:
      return currentLevel !== SampleControlsFeatureLevel.OFF;
    case SampleControlsFeatureLevel.V2:
      return ![SampleControlsFeatureLevel.V1, SampleControlsFeatureLevel.OFF].includes(currentLevel);
    case SampleControlsFeatureLevel.V3:
      return ![
        SampleControlsFeatureLevel.V2,
        SampleControlsFeatureLevel.V1,
        SampleControlsFeatureLevel.OFF,
      ].includes(currentLevel);
    default:
      throw new Error(`Unexpected SCR feature level ${minimumLevel}`);
  }
}

export function hasMinimumSCRFeatureLevel(minimumLevel: SampleControlsFeatureLevel): boolean {
  return _isSCRFeatureLevelSupported(
    BenchlingConfig.INVENTORY_ENABLE_SAMPLE_CONTROL_FEATURES as SampleControlsFeatureLevel,
    minimumLevel
  );
}
